<template>
	<div class="flex flex-row justify-content-between align-items-center m-2 bg-grey flex-wrap gap-2">
		<div class="flex flex-row align-items-center flex-wrap gap-2">
			<div class="pi pi-bell text-xs mr-1" />
			<span class="mr-2">Alert sound:</span>
			<PSelectButton
				:allowEmpty="false"
				:options="options"
				optionLabel="label"
				optionValue="id"
				aria-labelledby="status-alert-sound"
				v-model="selection"
				@click="save()"
			/>
			<PButton
				icon="pi pi-play"
				label="Preview"
				rounded
				size="small"
				text
				@click="preview()"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Constants from '@/helpers/Constants'
import Utils from '@/utils/Utils'
import EventBus from '@/utils/EventBus'
import {
	ALERT_SOUND_OPTIONS,
	AlertSoundId,
	getAlertSoundId,
	playAlertSound,
	setAlertSoundId,
	unlockAlertSound,
} from '@/utils/AlertSound'

export default defineComponent({
	name: 'WStatusAlertSound',

	data() {
		return {
			selection: getAlertSoundId() as AlertSoundId,
			before: getAlertSoundId() as AlertSoundId,
			options: ALERT_SOUND_OPTIONS,
		}
	},

	created() {
		EventBus.on(Constants.EVENTS.STATUS_ALERT_SOUND_CHANGED, this.onSoundChanged)
	},

	beforeUnmount() {
		EventBus.off(Constants.EVENTS.STATUS_ALERT_SOUND_CHANGED, this.onSoundChanged)
	},

	methods: {
		save() {
			unlockAlertSound()
			if (this.selection === this.before) {
				return
			}
			setAlertSoundId(this.selection)
			EventBus.emit(Constants.EVENTS.STATUS_ALERT_SOUND_CHANGED, this.selection)
			playAlertSound(this.selection)
			Utils.showSuccessMessage('Settings have been saved succcessfully.')
			this.before = this.selection
		},

		preview() {
			unlockAlertSound()
			playAlertSound(this.selection)
		},

		onSoundChanged(id: unknown) {
			if (typeof id === 'string' && ALERT_SOUND_OPTIONS.some((o) => o.id === id)) {
				this.selection = id as AlertSoundId
				this.before = id as AlertSoundId
			}
		},
	},
})
</script>
